import React, { useEffect, useState } from "react";

function formatTime(dateValue) {
  if (!dateValue) {
    return "";
  }
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export default function ChatInbox({
  threads,
  connecting,
  error,
  members,
  canSend,
  onClose,
  onOpenThread,
  onStartDirect,
  onLoadMembers,
}) {
  const [pickingMember, setPickingMember] = useState(false);

  useEffect(() => {
    if (pickingMember && onLoadMembers) {
      onLoadMembers().catch(() => {});
    }
  }, [pickingMember, onLoadMembers]);

  return (
    <section className="chat-panel">
      <header className="chat-panel-header">
        <span className="chat-panel-title">Chats</span>
        <button type="button" className="chat-panel-close" onClick={onClose}>
          ×
        </button>
      </header>
      <div className="chat-panel-body chat-inbox-body">
        {error ? <div className="chat-error">{error}</div> : null}
        {connecting && !threads.length ? (
          <div className="chat-empty">Connecting…</div>
        ) : null}
        {pickingMember ? (
          <div>
            <button
              type="button"
              className="chat-inbox-back-link"
              onClick={() => setPickingMember(false)}
            >
              ← Back to chats
            </button>
            {(members || []).length ? (
              members.map((member) => (
                <button
                  key={member.id}
                  type="button"
                  className="chat-inbox-row"
                  onClick={() => {
                    setPickingMember(false);
                    onStartDirect(member.id, member.name || member.userName);
                  }}
                >
                  <div className="chat-inbox-row-main">
                    <span className="chat-inbox-name">
                      {member.name || member.userName || member.id}
                    </span>
                  </div>
                </button>
              ))
            ) : (
              <div className="chat-empty">No other users in this organization.</div>
            )}
          </div>
        ) : (
          threads.map((thread) => (
            <button
              key={thread.id}
              type="button"
              className="chat-inbox-row"
              onClick={() => onOpenThread(thread.id)}
            >
              <div className="chat-inbox-row-main">
                <span className="chat-inbox-name">{thread.title}</span>
                <span className="chat-inbox-time">{formatTime(thread.lastMessageAt)}</span>
              </div>
              <div className="chat-inbox-row-sub">
                <span className="chat-inbox-preview">{thread.preview}</span>
                {thread.unread > 0 ? (
                  <span className="chat-inbox-unread">
                    {thread.unread > 99 ? "99+" : thread.unread}
                  </span>
                ) : null}
              </div>
            </button>
          ))
        )}
      </div>
      {canSend && !pickingMember ? (
        <div className="chat-inbox-footer">
          <button type="button" onClick={() => setPickingMember(true)}>
            New chat
          </button>
        </div>
      ) : null}
    </section>
  );
}
